export default __webpack_public_path__ + "static/media/wallet_connect_icon.1115f76e.svg";